import './Pochta.css';
import React, { useState } from 'react';
import WEm from './WEm';

function Pochta()
{
 const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

     return(
        <div className='pochta'>
<p style={{fontSize:'24px'}}>
  Если вы хотите узнать подробнее о своём типе личности: ваших сильных сторонах,скрытых талантах, совместимости с другими типами и о своих скрытых мотивах, то вы можете получить полный разбор своего типа введя свой адрес электронной почты. 
</p>
     <div className="catalog-footer">
      <button className="catalog-btn" onClick={handleOpenModal}>
        Получить эксклюзивное послание
      </button>
     </div>
      <WEm
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
       );
}
export default Pochta;